import { Icon } from '#/components/Icon/Icon';
import type { SocialNetwork } from '#/types/SocialNetwork';
import { getSocialNetworkFromLink } from '#/utils/social/getSocialNetworkFromLink';
import { iconNameBySocialNetwork } from '#/utils/social/iconNameBySocialNetwork';

import {
  ViewOrgPageSidebarLink,
  ViewOrgPageSidebarLinkCandid,
  ViewOrgPageSidebarLinkLi,
  ViewOrgPageSidebarLinkUl,
} from './ViewOrgPage.styled';

const socialNetworkLabels: Record<SocialNetwork, string> = {
  candid: 'Candid',
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  tiktok: 'TikTok',
  x: 'X',
  youtube: 'YouTube',
};

type Props = {
  links: string[];
  qaId: string;
};

export function ViewOrgPageSocialLinks({ links, qaId }: Props) {
  const socialLinks = links
    .map((link) => {
      const socialNetwork = getSocialNetworkFromLink(link);
      if (!socialNetwork) return;

      return { link, socialNetwork };
    })
    .filter(Boolean);

  if (socialLinks.length === 0) return null;

  return (
    <ViewOrgPageSidebarLinkUl data-qa-id={qaId}>
      {socialLinks.map(({ socialNetwork, link }) => {
        const label = socialNetworkLabels[socialNetwork];
        const LinkComponent =
          socialNetwork === 'candid'
            ? ViewOrgPageSidebarLinkCandid
            : ViewOrgPageSidebarLink;

        return (
          <ViewOrgPageSidebarLinkLi key={link}>
            <LinkComponent href={link} title={label} aria-label={label}>
              <Icon name={iconNameBySocialNetwork[socialNetwork]} size={16} />
            </LinkComponent>
          </ViewOrgPageSidebarLinkLi>
        );
      })}
    </ViewOrgPageSidebarLinkUl>
  );
}
